import { useEffect, useState } from 'react';

import CertificateAPI from '../../certificate/CertificateAPI';
import { CertificateTemplate } from '../../certificate/types/Certificate';
import Course from '../../course/types/Course';

export const useCourseCertificateTemplates = (
  courseId: Course['id'] | undefined,
  enabled = true,
): { templates: CertificateTemplate[]; loading: boolean } => {
  const [fetched, setFetched] = useState<{
    courseId?: Course['id'];
    templates: CertificateTemplate[];
  }>({ templates: [] });

  useEffect(() => {
    if (courseId == null || !enabled) return;

    let active = true;
    void CertificateAPI.getCourseCertificateTemplates(courseId)
      .then(({ data }) => {
        if (active) setFetched({ courseId, templates: data });
      })
      .catch(() => {
        if (active) setFetched({ courseId, templates: [] });
      });

    return () => {
      active = false;
    };
  }, [courseId, enabled]);

  // Switching course mustn't leave the previous course's templates on offer for the render
  // before the refetch lands
  const isCurrentCourse = fetched.courseId === courseId;

  return {
    templates: isCurrentCourse ? fetched.templates : [],
    loading: enabled && courseId != null && !isCurrentCourse,
  };
};
